module.exports = __webpack_public_path__ + "img/7.fba897c0.jpg";